import {
  Avatar,
  Box,
  Checkbox,
  Chip,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import SaveIcon from '@mui/icons-material/Save'
import React, { FC, useState } from 'react'
import { MaterialType, materialTypeValues } from '../../api/appAPI'
import emptyMaterial from '../../assets/emptyMaterial.png'
import { MaterialChipType } from '../Hardware/HardwareUIBox'
import { Flex } from '../common/Helpers'

type TextfieldProps = {
  value: string
  onChange(event: React.ChangeEvent<{ value: unknown }>): void
}

interface IProps {
  title: string

  name: TextfieldProps

  materialsChips: {
    chips: Array<MaterialChipType>
    deleteChip(chip: MaterialChipType): void
    addChip(chip: MaterialChipType): void
  }

  button: {
    text: string
    onClick(): void
  }

  needSave?: boolean
  // editable: boolean

  materials: MaterialType[]

  openMaterialDetails(id: number): void
}

const formatMaterialName = (m: MaterialType) => {
  const maxLens = {
    name: 30,
    sku: 20,
    price: 10,
    description: 30,
  }

  function formatValue(val: string, maxLen: number) {
    if (val === undefined || val === null) val = ''
    val = String(val)

    if (val.length > maxLen) {
      return val.slice(0, maxLen - 3) + '...'
    } else {
      return val.padEnd(maxLen, ' ')
    }
  }

  const formatted = Object.keys(maxLens).map((key) => {
    // @ts-ignore
    return formatValue(m[key], maxLens[key])
  })

  return formatted.join(' | ')
}

const MaterialGroupUIBox: FC<IProps> = (props) => {
  const [searchValue, setSearchValue] = useState('')

  const handleMaterialClick = (chip: MaterialChipType) => {
    if (props.materialsChips.chips.find((ch) => ch.id === chip.id)) {
      props.materialsChips.deleteChip(chip)
    } else {
      props.materialsChips.addChip(chip)
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      pb={2}
      style={{
        width: 400,
        height: 'fit-content',
        margin: 15,
        border: '1px solid black',
        maxHeight: '90%',
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        py={1}
        style={{
          position: 'sticky',
          top: 0,
          width: '100%',
          backgroundColor: 'white',
          zIndex: 10,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            {' '}
          </Grid>
          <Grid
            item
            xs={6}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="h6">{props.title}</Typography>
          </Grid>
          <Grid
            item
            xs={3}
            container
            justifyContent="flex-end"
            alignItems="center"
          >
            <Tooltip
              title={props.title === 'New Material Group' ? 'Create' : 'Save'}
            >
              <Fab
                color={props.needSave ? 'secondary' : 'primary'}
                size="small"
                onClick={props.button.onClick}
                style={{ marginRight: 10 }}
              >
                {props.title === 'New Material Group' ? (
                  <NoteAddIcon />
                ) : (
                  <SaveIcon />
                )}
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <TextField
        label="Material Group Name"
        variant="outlined"
        value={props.name.value}
        onChange={props.name.onChange}
        style={{ width: '60%', marginTop: 15 }}
        // disabled={!props.editable}
      />

      <Typography>Materials</Typography>

      <Box
        component="ul"
        px={1}
        my={1}
        style={{
          display: 'flex',
          justifyContent: 'center',
          columnGap: 10,
          rowGap: 10,
          flexWrap: 'wrap',
          listStyle: 'none',
        }}
      >
        {props.materialsChips.chips.map((chip) => (
          <li key={chip.id}>
            {!chip.isGroup && (
              <Chip
                label={chip.name}
                avatar={
                  <Avatar
                    alt="Material Icon"
                    src={chip.img ? chip.img : emptyMaterial}
                  />
                }
                onDelete={() => {
                  // if (props.editable)
                  props.materialsChips.deleteChip(chip)
                }}
                // color={chip.id === props.defaultMaterialId.value ? 'primary' : undefined}
                onClick={(e) => {
                  if (e.ctrlKey) props.openMaterialDetails(chip.id)
                  // else if (props.editable)
                  //     props.defaultMaterialId.set(chip.id)
                }}
              />
            )}
          </li>
        ))}
      </Box>

      <FormControl
        variant="outlined"
        style={{ width: '60%', marginTop: 15 }}
        // disabled={!props.editable}
      >
        <InputLabel>Select materials</InputLabel>
        <Select
          value={''}
          // onChange={props.markup.onChange}
          label="Select materials"
        >
          <Box sx={{ pl: 2, pt: 2 }}>
            <TextField
              label="Search"
              variant="outlined"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </Box>
          {materialTypeValues.map((type) => {
            const materials = props.materials.filter(
              (m) =>
                m.type === type &&
                m.name.toLowerCase().includes(searchValue.toLowerCase())
            )

            return (
              <Box key={type}>
                <ListSubheader>{type}</ListSubheader>
                {materials.map((m) => (
                  <Flex
                    style={{ gap: 0, cursor: 'pointer' }}
                    centerY
                    key={m.id}
                    onClick={() => {
                      handleMaterialClick({
                        id: m.id,
                        name: m.name,
                        img: m.thumbnail,
                        isGroup: false,
                      })
                    }}
                  >
                    <Checkbox
                      checked={
                        !!props.materialsChips.chips.find(
                          (ch) => ch.id === m.id
                        )
                      }
                    />
                    <MenuItem
                      style={{
                        fontFamily: 'monospace',
                        whiteSpace: 'pre',
                      }}
                    >
                      {/* {m.name} - {m.sku} - {m.description} */}
                      {formatMaterialName(m)}
                    </MenuItem>
                  </Flex>
                ))}
              </Box>
            )
          })}
        </Select>
      </FormControl>
    </Box>
  )
}

export default MaterialGroupUIBox
